export default __webpack_public_path__ + "static/media/green_base.057a5362.png";